import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const AccountHubEmptyState: FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      gap: 2,
      color: 'text.disabled',
      p: 4,
      textAlign: 'center',
    }}
  >
    <ManageAccountsIcon sx={{ fontSize: 64 }} />
    <Typography variant="body1" color="text.secondary">
      Select an option from the menu
    </Typography>
  </Box>
);

export default AccountHubEmptyState;
